module.exports = __webpack_public_path__ + "media/maleon-component.459bb844.mp4";